import { Button, Inline } from 'canoe';
import React from 'react';

interface ButtonFooterProps {
  onCancel: () => void;
  onSave: () => void;
}

export const ButtonFooter = ({ onCancel, onSave }: ButtonFooterProps) => {
  return (
    <Inline justify="flex-end">
      <Button appearance="text" variant="white" onClick={onCancel}>
        Cancel
      </Button>
      <Button darkBackground appearance="outline" variant="secondary" onClick={onSave}>
        Save
      </Button>
    </Inline>
  );
};
